"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Meltworks = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Options_1 = require("../Options");
var Meltworks = (function (_super) {
    __extends(Meltworks, _super);
    function Meltworks() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.MELTWORKS,
            tags: [Tags_1.Tags.BUILDING],
            cost: 4,
            metadata: {
                cardNumber: 'X26',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Spend 5 heat to gain 3 steel.', function (eb) {
                        eb.heat(5, { digit: Options_1.digit }).startAction.steel(3);
                    });
                }),
            },
        }) || this;
    }
    Meltworks.prototype.play = function (_player) {
        return undefined;
    };
    Meltworks.prototype.canAct = function (player) {
        return player.availableHeat >= 5;
    };
    Meltworks.prototype.action = function (player) {
        return player.spendHeat(5, function () {
            player.steel += 3;
            return undefined;
        });
    };
    return Meltworks;
}(Card_1.Card));
exports.Meltworks = Meltworks;
